import React from "react";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const ReplyComposerBar = ({ replyTo, contactName = "Contact", onCancel }) => {
  if (!replyTo?.text) {
    return null;
  }

  const isQuotedFromMe = replyTo.from === "me";
  const senderLabel = isQuotedFromMe ? "You" : contactName;
  const accentColor = isQuotedFromMe ? "#06cf9c" : "#53bdeb";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 14px",
        margin: "4px 0 8px",
        background: "#f0f4f9",
        borderRadius: "8px",
        borderLeft: `4px solid ${accentColor}`,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          flex: 1,
          minWidth: 0,
        }}
      >
        <div
          style={{
            color: accentColor,
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1.3,
            marginBottom: 2,
          }}
        >
          {senderLabel}
        </div>
        <div
          style={{
            color: "#667781",
            fontSize: 13,
            lineHeight: 1.35,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {replyTo.text}
        </div>
      </div>
      <Button
        type="text"
        size="small"
        aria-label="Cancel reply"
        icon={<CloseOutlined />}
        onClick={onCancel}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    </div>
  );
};

export default ReplyComposerBar;
